/* eslint-disable react-hooks/exhaustive-deps */
import { Paper } from "@mui/material";
import { Location } from 'history'
import { FC, useCallback, useEffect, useState } from "react"
import { useHistory, Prompt } from "react-router-dom";
import { DEFAULT_PROJETO, DEFAULT_PROJETO_AVULSO, NOME_CLIENTE_MAX_LENGTH, PROJETOS_CUSTO_ANUAL_MANUTENCAO_GERADOR_PARAM } from "src/components/projetos/constants";
import { Verticais } from "src/components/vendas/types";
import { VerticaisManager, paths } from "src/components/vendas/VerticaisManager";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { ContaProvider } from "src/providers/cadastros/ContaProvider";
import { EquipeType, ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { getCidades, getGruposEstrutura, getEstados, getLimitacoesProjetos, getDistribuidoresPorTipoDeConta, getRevendas, distribuidoresPorTipoDeConta$, revendas$, getEstadosServico, getRegioes, regioes$, getDistribuidores, contaUsuario$, CacheType, verificarSegmentoConta } from "src/store/global.store";
import { formState$ } from "src/store/vendas/projetos/store";
import { ConfiguracaoStore } from "src/framework/store/ConfiguracaoStore";
import { ListUtil } from "src/framework/commons/ListUtil";
import { Projeto, ProjetoTipoType, SegmentoType, TipoProposta } from "./types";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { ContaUsuario } from "src/store/global.store.types";
import { notifierStore } from "src/framework/store/NotifierStore";
import { isLoading$, standAlonePage$ } from "src/framework/store/ApiEvents";
import { FormDadosAvulso } from "./FormDadosAvulso";
import { KitConfirmationModal } from "./kits/containers/KitConfirmationModal";
import { salvarProjeto } from "./utils/salvarProjeto";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import { MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR, MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA, MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";

interface FormInicialProperties {
  segmento?: SegmentoType;
}

const TITULO_MAX_LENGTH = 100
const MSG_FALHA_GERAR_PAGAMENTO = "Falha ao enviar pedido para pagamento";

const manager: VerticaisManager = new VerticaisManager(paths, api, apiNoLoading);
const projetosProvider = new ProjetosProvider();
const contasProvider = new ContaProvider();
const store = new ConfiguracaoStore(api, PROJETOS_CUSTO_ANUAL_MANUTENCAO_GERADOR_PARAM)

const initLoad = async () => {
  await Promise.all([
    getEstados(),
    getRegioes(),
    getCidades(),
    getGruposEstrutura(),
    getLimitacoesProjetos(),
    getDistribuidores(),
    getDistribuidoresPorTipoDeConta(),
    getRevendas(),
    getEstadosServico({ force: true })
  ])
}

const ProjetosFormInicialAvulso: FC<FormInicialProperties> = ({ segmento }) => {
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$);
  const history = useHistory<{ allowAccess?: boolean; noReset?: boolean; done?: boolean; tipo?: ProjetoTipoType }>();
  const formState = useObservable(formState$);
  const distribuidorsState = useObservable(distribuidoresPorTipoDeConta$);
  const regioes = useObservable(regioes$)
  const revendasState = useObservable(revendas$);
  const standAlone = useObservable(standAlonePage$)
  const [kitConfirmationModalIsOpened, setKitConfirmationModalIsOpened] = useState(false)
  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const formStateGlobal = formState$.getValue();

  const [checkSegmentoConta, setCheckSegmentoConto] = useState<boolean>(false);
  const [errorState, setErrorState] = useState<string[]>([]);
  const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<any>(null);
  const [row, setRow] = useState(formStateGlobal);
  const [oldFormState] = useState(DEFAULT_PROJETO_AVULSO)
  
  useEffect(()=>{
    const queryParams = new URLSearchParams(history.location.search);
    const tipo = queryParams.get('tipo') || row?.tipo || "dimensionado"  
    setRow((old: any) => ({...old, tipo }))
  },[history.location.search, row?.tipo])

  const canNavigate = useCallback((location: Location | null = null)=>{
    const allowedLocations = ['/projetos/.*/novo', 'edicao$', 'clonar$']
    const localLocation = location || history.location

    const loc = localLocation as Location<{ done: boolean }>

    return loc.state?.done || allowedLocations.some(item => {
      return loc?.pathname.match(new RegExp(item))
    })
  },[history.location])

  useEffect(()=>{
    if (standAlone !== undefined && !standAlone) {
      store.list().then(res => {})
    }
  },[standAlone])

  useEffect(() => {
    return () => {
      if (!canNavigate()) {
        formState$.next(DEFAULT_PROJETO_AVULSO)
      }
    }
  },[canNavigate, history])

  const init = useCallback(()=>{
    const _distribuidorRevendaUsuario: any = LocalStorage.get("solar.userExtraInfo", true)
    setDistribuidorRevendaUsuario(_distribuidorRevendaUsuario)
  },[])

  useEffect(() => {
    initLoad().then(() => {
      init()
    })
  }, [init]);  
  
  useEffect(()=>{
    if (!checkSegmentoConta && row?.segmento) {
      verificarSegmentoConta({ 
        goBack: true,
        segmento: row?.segmento ||'on', 
        revendaId: row?.revenda_id || row?.revenda?.id || undefined, 
        distribuidorId: row?.distribuidor_id || row?.distribuidor?.id || undefined,
      });
      setCheckSegmentoConto(true);
    }
  },[row?.segmento, row?.revenda_id, row?.distribuidor_id, row?.revenda?.id, row?.distribuidor?.id, checkSegmentoConta]);
  
  const afterSave = useCallback(() => {
    const cleanAndRedirect = () => {
      notifierStore.setOpen(false);
      history.replace('/projetos/menu-projetos', { done: true })
      formState$.next(DEFAULT_PROJETO)
    }

    notifierStore.setNotifier({
      content: ['<strong>Obrigado pela sua compra !</strong>', '</br>','O link para pagamento foi enviado para o e-mail informado na compra. Não se esqueça de efetuar o pagamento para que seu pedido seja confirmado.'],
      title: 'Sucesso!',
      onClose: () => cleanAndRedirect(),
      timeOut: 0
    })
    notifierStore.setOpen(true)
    isLoading$.next(false);
  }, [history])
  
  const rollbackSave = useCallback((idProjeto: number | undefined, message?: string[]) => {
    isLoading$.next(false);
    const remove = async () => {
      const request: IDataRequest = {
        url: `/projetos/deletar/${idProjeto}`,
        data: { motivo: MSG_FALHA_GERAR_PAGAMENTO }
      }
      await api.put(request);
    }

    notifierStore.setNotifier({
      content: (message && message?.some(i => i?.includes("pagamento bloqueado"))) ? message : ['Não foi possível finalizar a sua compra. Tente novamente mais tarde.'],
      title: 'Atenção!',
      onClose: () => notifierStore.setOpen(false),
      timeOut: 0
    })

    if (idProjeto) remove();
    notifierStore.setOpen(true)
  }, [])

  const showErrorMessage = (message: any) => {
    isLoading$.next(false);
    setKitConfirmationModalIsOpened(false);
    notifierStore.setOpen(false);
    if (message?.length) {
      notifierStore.setNotifier({
        title: "Aviso!",
        content: message,
        timeOut: 3000,
        onClose: () => {
          notifierStore.setOpen(false);
        }
      })
      notifierStore.setOpen(true);
    }
  }

  const showMessageApi = (mensagem: string) => {
    isLoading$.next(false);
    setKitConfirmationModalIsOpened(false);
    notifierStore.setOpen(false);
    notifierStore.setNotifier({
      title: "Atenção!",
      content: mensagem,
      timeOut: 2500,
      onFinishTimeout: () => {
        window.location.href = `${window.location.origin}/projetos/menu-projetos`
      },
      onClose: () => {
        notifierStore.setOpen(false);
        window.location.href = `${window.location.origin}/projetos/menu-projetos`
      },
    });
    notifierStore.setOpen(true);
  }

  const save = useCallback((updatedFormState: Partial<Projeto> = {})=>{
    isLoading$.next(true);

    const payload = {
      ...formState,
      ...updatedFormState,
    }

    salvarProjeto(manager, formState?.id, payload, authUser)
    .then(async(response: IDataResponse) => {
      isLoading$.next(true);
      const allowedStatusCode = [STATUS_CODE.OK, STATUS_CODE.CREATED]
      if(allowedStatusCode.includes(response.statusCode)) {
        setKitConfirmationModalIsOpened(false)

        let pagamento = null;
        const codigoVenda = response?.data?.[0]?.codigo_venda || payload.codigo_venda
        if (codigoVenda && payload.tipo_proposta_projeto) {
          pagamento = await projetosProvider.enviarParaPagamento({
            codigo_venda: codigoVenda,
            nota_fiscal_triangular: payload.tipo_faturamento === "integrador_cliente",
            tipo_proposta_envio: payload.tipo_proposta_projeto,
          })
        }

        const successCode: any[] = [200,201,202];
        const enviouPagamento = successCode?.includes(pagamento?.statusCode) || pagamento?.message === 'OK';
        const projetoId = formState?.id || response?.data[0]?.id;

        if (enviouPagamento) {
          if (payload.tipo_proposta_projeto && codigoVenda) {
            await projetosProvider.enviarEmailProposta(codigoVenda, payload.tipo_proposta_projeto);
          }
          afterSave()
        } else {
          let _message: string[] = [];
          const msg = pagamento?.message;

          if (Array.isArray(msg)) {
            _message = [...msg];
          } else if (typeof msg === 'string') {
            _message = [msg];
          }

          rollbackSave(projetoId, _message);
        }
      } else {
        if (response?.message) {
          const message: string[] = Array.isArray(response?.message) ? response?.message : [response?.message];
          const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || message?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
          const mensagemSegmentoRevenda = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
          const mensagemSegmentoDistribuidor = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));
          if (mensagemVigencia) {
            showMessageApi(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO);
          } else if (mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
            showMessageApi(`${mensagemSegmentoRevenda ? MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA : MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR}.`);
          } else {
            showErrorMessage(response?.message);
          }
        }
      }
    }).catch((error: any) => {
      if (error?.message) {
        const message: string[] = Array.isArray(error?.message) ? error?.message : [error?.message];
        const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) 
        || message?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));

        const mensagemSegmentoRevenda = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) 
          || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
            
        const mensagemSegmentoDistribuidor = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) 
          || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));

        if (mensagemVigencia) {
          showMessageApi(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO);
        } else if (mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
          showMessageApi(`${mensagemSegmentoRevenda ? MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA : MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR}.`);
        } else {
          showErrorMessage(error?.message);
        }
      }
    })
  },[afterSave, formState])

  const beforeSave = useCallback((tipoProposta: TipoProposta, emailProposta: any) => {
    save({ tipo_proposta_projeto: tipoProposta, email_proposta: emailProposta })
  },[formState, save])

  const validate = useCallback(() => {
    const _errorState = [...errorState]
    const messages: string[] = [];

    const data: Verticais = {...row}

    if (!data?.cliente_proposta){
      messages.push("O campo nome do cliente é obrigatório");
      _errorState.push("cliente_proposta")
    }

    if (data?.cliente_proposta && data?.cliente_proposta.length > NOME_CLIENTE_MAX_LENGTH) {
      messages.push(`O campo nome do cliente deve ter no máximo ${NOME_CLIENTE_MAX_LENGTH} caracteres`);
      _errorState.push("cliente_proposta")
    }

    if (data?.titulo && data?.titulo?.length > TITULO_MAX_LENGTH) {
      messages.push("O campo título deve ter no máximo 100 caracteres");
      _errorState.push("titulo")
    }

    if (!data?.distribuidor_id && !data?.distribuidor?.id) {
        messages.push("O campo distribuidor é obrigatório");
        _errorState.push("distribuidor_id")
    }

    if(data?.email_proposta){
      if (!ValidateUtil.isValidEmail(data?.email_proposta)) {
        messages.push("E-mail inválido");
        _errorState.push("email_proposta")
      }else{
        ListUtil.removeItem(_errorState, "email_proposta")
      }
    }else{
      ListUtil.removeItem(_errorState, "email_proposta")
    }

    if (messages.length > 0) {
      setErrorState(_errorState)
      notifierStore.setNotifier({
          title: "Aviso",
          content: messages,
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true)
    }

    return messages.length === 0;
  }, [errorState, row])
 
  const captureData = useCallback(async(data: any) => {
    if (!validate()) return

    const state = { ...data };

    const distribuidores = distribuidoresPorTipoDeConta$.getValue();

    if (state?.distribuidor === undefined) {
      const idxDistribuidor = distribuidores.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.distribuidor_id)
      if (idxDistribuidor > -1) {
        state.distribuidor = distribuidores.data[idxDistribuidor]
      }
    }

    if (state?.revenda === undefined) {
      const idxRevenda = revendasState?.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.revenda_id)
      
      if (idxRevenda > -1) {
        state.revenda = revendasState.data[idxRevenda]
      } else {
        if (distribuidorRevendaUsuario?.revenda_id && distribuidorRevendaUsuario?.revenda_nome && distribuidorRevendaUsuario?.revenda_cnpj_cpf) {
          state.revenda = {
            id: distribuidorRevendaUsuario.revenda_id,
            nome: distribuidorRevendaUsuario.revenda_nome,
            cnpj_cpf: distribuidorRevendaUsuario.revenda_cnpj_cpf,
          }
        }
      }
    }

    const cpfCnpjDistribuidor = state?.distribuidor?.cnpj_cpf;

    if (!state?.codigo_venda) {
      if (cpfCnpjDistribuidor === "" || cpfCnpjDistribuidor === undefined || cpfCnpjDistribuidor === null) {
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: "Distribuidor não informado ou CNPJ inválido!",
            timeOut: 3000,
            onClose: () => {
                notifierStore.setOpen(false);
            }
        })
        notifierStore.setOpen(true);
        return;
      }
    }

    const hasRevenda = !!state?.revenda;

    if ((oldFormState?.distribuidor?.id !== state?.distribuidor?.id) || (oldFormState?.distribuidor?.id === state?.distribuidor?.id && hasRevenda && oldFormState?.revenda?.id !== state?.revenda?.id)) {
      let codigoDistribuidorRevenda = state?.distribuidor?.id;
      
      if (hasRevenda) {
          codigoDistribuidorRevenda = state?.revenda?.id;
      }

      const responseEquipe: EquipeType | null = await contasProvider.getEquipe(codigoDistribuidorRevenda, state.segmento);

      state.ev_id = responseEquipe?.ev_id;
      state.supervisor_id = responseEquipe?.supervisor_id;
      state.assistente_id = responseEquipe?.assistente_id;
    }
    
    state.distribuidor_id = state?.distribuidor?.id;
    state.cidade_id = state?.cidade?.id;
    state.estado_id = state?.estado?.id;
    
    return state;
  },[distribuidorRevendaUsuario, revendasState, oldFormState?.distribuidor?.id, oldFormState?.revenda?.id, validate])

  useEffect(() => {
    const permissions = PermissionUtil.getPermissions();
    if (!formState?.isEdit && PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VISUALIZAR_FILIAIS, permissions) && !PermissionUtil.isAdministrador(permissions) && contaUsuario?.data?.filiais?.length && contaUsuario?.data?.distribuidor?.id) {
      setRow((old: any) => ({...old, distribuidor_id: contaUsuario?.data?.distribuidor?.id, distribuidor: contaUsuario?.data?.distribuidor }))
    }
  },[contaUsuario?.data?.distribuidor, contaUsuario?.data?.filiais?.length, formState?.isEdit])

  useEffect(() => {
    if (distribuidorRevendaUsuario && !row?.distribuidor?.id) {
          if (!distribuidorRevendaUsuario.isIntelbras) {
            row.distribuidor_id = distribuidorRevendaUsuario?.distribuidor_id;

              const distribuidores = distribuidorsState.data;
              const distribuidorIdx = distribuidores.findIndex((d: any) => d.id === row.distribuidor_id)
              if (distribuidorIdx > -1) {
                row.distribuidor = distribuidores[distribuidorIdx];
              }

              if (distribuidorRevendaUsuario?.revenda_id) {
                  row.revenda_id = distribuidorRevendaUsuario?.revenda_id;
                  const revendas = revendas$.getValue().data;
                  const revendaIdx = revendas.findIndex((r) => r.id === row.revenda_id)
                  if (revendaIdx > -1) {
                    row.revenda = revendas[revendaIdx];
                  }
              }

              if (standAlone) {
                row.segmento = 'vertical_ongrid'
                row.tipo = 'vertical'
              }

              setRow(row)
              verificarSegmentoConta({ 
                goBack: true,
                segmento: row?.segmento ||'on', 
                revendaId: row?.revenda_id || row?.revenda?.id || undefined, 
                distribuidorId: row?.distribuidor_id || row?.distribuidor?.id || undefined,
              });
          }
      }

  }, [row, distribuidorRevendaUsuario, distribuidorsState, revendasState]);

  const handleChangeValue = (newState: any) => {
    const globalFormState = formState$.getValue();
    setRow({...globalFormState, ...newState});
    formState$.next({...globalFormState, ...newState})
  }

  return (
      <>
      <Paper elevation={0}>
        <FormDadosAvulso
          formState={row}
          onChangeValue={(newState: any) => handleChangeValue(newState)}
          errorState={errorState}
          onChangeError={(newErrorState: any) => setErrorState(newErrorState)}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onClickNext={async() => {
            const result = await captureData(row)
            if (!result) return;
            const state = { ...result } 
              if (state?.estado?.id) {
                const currentRegioes = regioes.data.filter((regiao: any) => {
                  const estadosList = regiao.estados || []


                  const estados = estadosList.map((item: any) => item.estado_id)
                  return estados.includes(state?.estado?.id)
                })
                state.regioes = currentRegioes
              }

              state.codigo_venda = result.codigo_venda

              handleChangeValue(state)
              setKitConfirmationModalIsOpened(true);
          }}
        />
      </Paper>
      {kitConfirmationModalIsOpened &&
        <KitConfirmationModal
          isOpened={kitConfirmationModalIsOpened}
          close={() => setKitConfirmationModalIsOpened(false)}
          onConfirm={beforeSave}
          showPropostaOptions={false}
          emailPropostaOriginal={formState?.email_proposta}
        />
      }
      <Prompt when={!!formState?.codigo_venda} message={(location) => {
        if (canNavigate(location)) return true;
        return `Deseja cancelar a ${formState?.isEdit ? 'edição' : 'criação'} do projeto?`
      }}/>
    </>
  )    
}

export { ProjetosFormInicialAvulso }